import React, { useState, useRef } from "react";
// react component for creating dynamic tables
//import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { useHistory } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
// import CardActions from "@material-ui/core/CardActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import dateFormat from "dateformat";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import tableComponentStyles from "assets/theme/views/admin/tables.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { Check, Block } from "@material-ui/icons";
import {
  redirectToLogout,
  parseWashingFeatures,
  openInNewTab,
  zeroFill,
  getIsPickedFromLaundry,
  isSaudi
} from "common/SharedFn";
import DatePicker from "react-datepicker";
import {
  getOrderDetails,
  getSubscriptionDetails,
  getCities,
  bulkAssignDriver,
  bulkUpdateOrderStatus,
  getAllStatus,
  getAllActiveDrivers,
  getAllSlots,
  updateOrderPickupDropoff,
  bulkAssignLaundries,
  getAllActiveLaundries,
  updateOrderNotes,
  markOrderForRewash,
  getPendingApprovalOrderRecords,
  bulkUpdateOrderBagRecordStatus,
  updateShowToUser,
  getAllServices,
  addComplaint,
} from "../../network/ApiAxios";
import { ArrowBack, Edit, Image, Clear } from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const useStylesTables = makeStyles(tableComponentStyles);

const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

// const { SearchBar } = Search;

// const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const OrderDetailsPage = (props) => {
  const classes = {
    ...useStyles(),
    ...useStylesButtons(),
    ...useStylesTables(),
  };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [order, setOrder] = useState();
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [drivers, setDrivers] = useState([]);
  const [slots, setSlots] = useState([]);
  const [pendingApprovalRecords, setPendingApprovalRecords] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [subscription, setSubscription] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeRecordUpdate, setExecuteRecordUpdate] = useState(false);
  const [exectueRewash, setExecuteRewash] = useState(false);
  const [laundries, setLaundries] = useState([]);
  const [services, setServices] = useState([]);
  const [notesModal, setNotesModal] = useState(false);
  const [assignLaundryModal, setAssignLaundryModal] = useState(false);
  const [assignedLaundryId, setAssignedLaundryId] = useState(0);
  const [executeAssignLaundry, setExecuteAssignLaundry] = useState(false);
  const [assignDriverModal, setAssignDriverModal] = useState(false);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [assignedDriverId, setAssignedDriverId] = useState(0);
  const [assignDriverType, setAssignDriverType] = useState(1);
  const [updateOrderModal, setUpdateOrderModal] = useState(false);
  const [markForRewashModal, setMarkForRewashModal] = useState(false);
  const [newStatus, setNewStatus] = useState(1);
  const [executeAssignDriver, setExecuteAssignDriver] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [refundToWallet, setRefundToWallet] = useState(1);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [cities, setCities] = useState([]);
  const [id, setId] = useState();
  const [pickupDate, setPickupDate] = useState();
  const [pickupTimeslot, setPickupTimeslot] = useState(0);
  const [pickupFlat, setPickupFlat] = useState("");
  const [pickupHouse, setPickupHouse] = useState("");
  const [pickupRoad, setPickupRoad] = useState("");
  const [pickupBlock, setPickupBlock] = useState("");
  const [pickupShortAddress, setPickupShortAddress] = useState("");
  const [pickupDistrictName, setPickupDistrictName] = useState("");
  const [portalNotes, setPortalNotes] = useState("");
  const [pickupCityId, setPickupCityId] = useState(0);
  const [pickupAddressType, setPickupAddressType] = useState("");
  const [pickupAddressInstructions, setPickupAddressInstructions] =
    useState("");
  const [pickupInstructions, setPickupInstructions] = useState("");
  const [pickupLocationCoordinates, setPickupLocationCoordinates] =
    useState("");

  const [dropoffDate, setDropoffDate] = useState();
  const [showToUser, setShowToUser] = useState(1);
  const [dropoffTimeslot, setDropoffTimeslot] = useState(0);
  const [dropoffFlat, setDropoffFlat] = useState("");
  const [dropoffHouse, setDropoffHouse] = useState("");
  const [dropoffRoad, setDropoffRoad] = useState("");
  const [dropoffShortAddress, setDropoffShortAddress] = useState("");
  const [dropoffDistrictName, setDropoffDistrictName] = useState("");
  const [dropoffBlock, setDropoffBlock] = useState("");
  const [dropoffCityId, setDropoffCityId] = useState(0);
  const [dropoffAddressType, setDropoffAddressType] = useState("");
  const [dropoffAddressInstructions, setDropoffAddressInstructions] =
    useState("");
  const [dropoffInstructions, setDropoffInstructions] = useState("");
  const [dropoffLocationCoordinates, setDropoffLocationCoordinates] =
    useState("");


  const [rewashPickupDate, setRewashPickupDate] = useState();
  const [rewashPickupTimeslot, setRewashPickupTimeslot] = useState(0);
  const [rewashDropoffDate, setRewashDropoffDate] = useState();
  const [rewashDropoffTimeslot, setRewashDropoffTimeslot] = useState(0);

  // Complaint dialog state variables
  const [complaintCategory, setComplaintCategory] = useState(0); // Default to "Rewash" category
  const [complaintDescription, setComplaintDescription] = useState("");
  const [complaintImages, setComplaintImages] = useState([]);
  const [complaintImageUploadFiles, setComplaintImageUploadFiles] = useState([]);
  const complaintFileInputRef = useRef(null);
  const [complaintOrderId, setComplaintOrderId] = useState("");
  const [complaintUserId, setComplaintUserId] = useState("");

  // Complaint categories list
  const complaintCategoriesList = [
    { value: 0, name: "Rewash" }, // Only Rewash category
  ];



  var currentOrderId = props.match.params.id;
  let history = useHistory();
  const mapRef = React.useRef(null);

  const tableCellHeadTableHeadClassesObj = {
    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
  };

  let currency = localStorage.getItem("selectedCountry") == 2 ? "SAR" : "BHD";


  const warningAlert = (title, message, action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };


  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const assignDriverAction = async () => {
    setExecuteAssignDriver(false);
    setIsLoading(true);
    try {
      const response = await bulkAssignDriver([order.id], assignedDriverId, assignDriverType);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Driver Assigned Successfully");
        setAssignDriverModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to assign driver");
      setIsLoading(false);
    }
  };

  const updateOrderNotesAction = async () => {

    setIsLoading(true);
    try {
      const response = await updateOrderNotes(order.id, portalNotes);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Order notes updates successfully");
        setNotesModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update order notes");
      setIsLoading(false);
    }
  };

  const recordUpdateStatusAction = async (ids, newRecordUpdateStatus) => {
    setExecuteRecordUpdate(false);
    setIsLoading(true);
    try {
      const response = await bulkUpdateOrderBagRecordStatus(ids, newRecordUpdateStatus);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Order Updated Successfully");
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update order");
      setIsLoading(false);
    }
  };


  const assignLaundryAction = async () => {
    setExecuteAssignLaundry(false);
    setIsLoading(true);
    try {
      const response = await bulkAssignLaundries([order.id], assignedLaundryId);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Laundry Assigned Successfully");
        setAssignLaundryModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to assign laundry");
      setIsLoading(false);
    }
  };


  const updateStatusAction = async () => {
    setExecuteStatusUpdate(false);
    setIsLoading(true);
    try {
      const response = await bulkUpdateOrderStatus([order.id], newStatus, refundToWallet);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Status Updated Successfully");
        setUpdateStatusModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update status");
      setIsLoading(false);
    }
  };

  const tidyUpOrder = (order) => {
    order = parseWashingFeatures(order);
    order.placedOnText = dateFormat(
      new Date(order.placedOn),
      "d-mmm-yyyy hh:MM TT"
    );
    order.pickupDateText = dateFormat(new Date(order.pickupDate), "d-mmm-yyyy");
    order.dropoffDateText = dateFormat(
      new Date(order.dropoffDate),
      "d-mmm-yyyy"
    );
    if (order.pickupDateTime != null) {
      order.pickupDateTimeText = dateFormat(
        new Date(order.pickupDateTime),
        "d-mmm-yyyy hh:MM TT"
      );
    } else {
      order.pickupDateTimeText = "";
    }

    if (order.droppedOffAtLaundryOn != null) {
      order.droppedOffAtLaundryOnText = dateFormat(
        new Date(order.droppedOffAtLaundryOn),
        "d-mmm-yyyy hh:MM TT"
      );
    } else {
      order.droppedOffAtLaundryOnText = "";
    }

    if (order.dropoffTimeDate != null) {
      order.dropoffDateTimeText = dateFormat(
        new Date(order.dropoffTimeDate),
        "d-mmm-yyyy hh:MM TT"
      );
    } else {
      order.dropoffDateTimeText = "";
    }
    order.priceWithoutDiscountAndVat = (order.price + order.discountAmount + order.proDiscount).toFixed(3);

    order.paymentMethodName = order.paymentMethodByPaymentMethodId.name;
    if (order.walletBalanceUsed > 0 && order.paymentMethodByPaymentMethodId.id !== 4) {
      order.paymentMethodName = order.paymentMethodName + " + Wallet";
    }
    setCurrentRecord(order);
    return order;
  };

  const initMap = (pickupCoord, dropoffCoord) => {
    try {
      if (mapRef.current == null) {
        return;
      }
      let google = window.google;
      let splittedPickup = pickupCoord != null ? pickupCoord.split(",") : null;
      let splittedDropoff = dropoffCoord.split(",");
      let map = mapRef.current;
      let lat = splittedPickup == null ? splittedDropoff[0].trim() : splittedPickup[0].trim();
      let lng = splittedPickup == null ? splittedDropoff[1].trim() : splittedPickup[1].trim();
      const pickupLatLng = new google.maps.LatLng(lat, lng);
      const mapOptions = {
        zoom: 16,
        center: pickupLatLng,
        scrollwheel: false,
        zoomControl: true,
      };

      map = new google.maps.Map(map, mapOptions);

      const pickupMarker = new google.maps.Marker({
        position: pickupLatLng,
        map: map,
        animation: google.maps.Animation.DROP,
      });

      const pickupContentString =
        pickupCoord != null && pickupCoord === dropoffCoord
          ? '<div class="info-window-content"><h4>Pickup & Dropoff Location</h4></div>'
          : pickupCoord == null ? '<div class="info-window-content"><h4>Dropoff Location</h4></div>' : '<div class="info-window-content"><h4>Pickup Location</h4></div>';

      const pickupInfowindow = new google.maps.InfoWindow({
        content: pickupContentString,
      });

      google.maps.event.addListener(pickupMarker, "click", function () {
        pickupInfowindow.open(map, pickupMarker);
      });

      if (pickupCoord != null && pickupCoord !== dropoffCoord) {
        let lat2 = splittedDropoff[0].trim();
        let lng2 = splittedDropoff[1].trim();
        const dropoffLatLng = new google.maps.LatLng(lat2, lng2);
        const dropOffMarker = new google.maps.Marker({
          position: dropoffLatLng,
          map: map,
          animation: google.maps.Animation.DROP,
        });

        const dropoffContentString =
          '<div class="info-window-content"><h4>Dropoff Location</h4></div>';

        const dropoffInfowindow = new google.maps.InfoWindow({
          content: dropoffContentString,
        });

        google.maps.event.addListener(dropOffMarker, "click", function () {
          dropoffInfowindow.open(map, dropOffMarker);
        });
      }
    } catch (ex) {
      console.log("ERROR: EE " + ex);
    }
  };

  const setCurrentRecord = (info) => {
    const {
      id,
      pickupDate,
      pickupTimeslot,
      pickupFlat,
      pickupHouse,
      pickupRoad,
      pickupBlock,
      pickupDistrictName,
      pickupShortAddress,
      pickupCityId,
      pickupAddressType,
      pickupAddressInstructions,
      pickupInstructions,
      pickupLocationCoordinates,
      dropoffDate,
      dropoffTimeslot,
      dropoffFlat,
      dropoffHouse,
      dropoffRoad,
      dropoffBlock,
      dropoffDistrictName,
      dropoffShortAddress,
      dropoffCityId,
      dropoffAddressType,
      dropoffAddressInstructions,
      dropoffInstructions,
      dropoffLocationCoordinates,
      portalNotes
    } = info;
    setPickupDate(new Date(pickupDate));
    setPickupTimeslot(pickupTimeslot);
    setPickupFlat(pickupFlat);
    setPickupHouse(pickupHouse);
    setPickupRoad(pickupRoad);
    setPickupBlock(pickupBlock);
    setPickupDistrictName(pickupDistrictName);
    setPickupShortAddress(pickupShortAddress);
    setPickupCityId(pickupCityId);
    setPickupAddressType(pickupAddressType);
    setPickupAddressInstructions(pickupAddressInstructions);
    setPickupInstructions(pickupInstructions);
    setPickupLocationCoordinates(pickupLocationCoordinates);
    setPortalNotes(portalNotes);
    setDropoffDate(new Date(dropoffDate));
    setDropoffTimeslot(dropoffTimeslot);
    setDropoffFlat(dropoffFlat);
    setDropoffHouse(dropoffHouse);
    setDropoffRoad(dropoffRoad);
    setDropoffDistrictName(dropoffDistrictName);
    setDropoffShortAddress(dropoffShortAddress);
    setDropoffBlock(dropoffBlock);
    setDropoffCityId(dropoffCityId);
    setDropoffAddressType(dropoffAddressType);
    setDropoffAddressInstructions(dropoffAddressInstructions);
    setDropoffInstructions(dropoffInstructions);
    setDropoffLocationCoordinates(dropoffLocationCoordinates);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setPickupDate();
    setPickupTimeslot(0);
    setPickupFlat("");
    setPickupHouse("");
    setPickupRoad("");
    setPickupBlock("");
    setPickupCityId(0);
    setPickupDistrictName("");
    setPickupShortAddress("");
    setPickupAddressType("");
    setPickupAddressInstructions("");
    setPickupInstructions("");
    setPickupLocationCoordinates("");
    setPortalNotes("");
    setDropoffDate();
    setDropoffDate("");
    setDropoffTimeslot(0);
    setDropoffFlat("");
    setDropoffHouse("");
    setDropoffRoad("");
    setDropoffDistrictName("");
    setDropoffShortAddress("");
    setDropoffBlock("");
    setDropoffCityId(0);
    setDropoffAddressType("");
    setDropoffAddressInstructions("");
    setDropoffInstructions("");
    setDropoffLocationCoordinates("");
    setId();
    
    // Clear complaint form fields
    setComplaintCategory(0);
    setComplaintDescription("");
    setComplaintImages([]);
    setComplaintImageUploadFiles([]);
    setComplaintOrderId("");
    setComplaintUserId("");
    if (complaintFileInputRef.current) {
      complaintFileInputRef.current.value = null;
    }
  };


  const updateOrderAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try {
      const response = await updateOrderPickupDropoff(id,
        pickupDate,
        pickupTimeslot,
        pickupFlat,
        pickupHouse,
        pickupRoad,
        pickupBlock,
        pickupDistrictName,
        pickupShortAddress,
        pickupCityId,
        pickupAddressType,
        pickupAddressInstructions,
        pickupInstructions,
        pickupLocationCoordinates,
        dropoffDate,
        dropoffTimeslot,
        dropoffFlat,
        dropoffHouse,
        dropoffRoad,
        dropoffBlock,
        dropoffDistrictName,
        dropoffShortAddress,
        dropoffCityId,
        dropoffAddressType,
        dropoffAddressInstructions,
        dropoffInstructions,
        dropoffLocationCoordinates);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Order Updated Successfully");
        setUpdateOrderModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to update order");
      setIsLoading(false);
    }
  };

  const markForRewashAction = async () => {
    setExecuteRewash(false);
    
    // Validate complaint fields before proceeding with any API calls
    if (!complaintDescription || !complaintDescription.trim()) {
      showErrorNotification("Complaint description is required.");
      return;
    }
    
    setIsLoading(true);
    try {
      // First API call: Mark order for rewash
      const rewashResponse = await markOrderForRewash(id,
        new Date((rewashPickupDate.getTime() + 86400000)),
        rewashPickupTimeslot,
        new Date((rewashDropoffDate.getTime() + 86400000)),
        rewashDropoffTimeslot);
      
      const { data: rewashData } = rewashResponse;
      if (rewashData.result.isSuccess) {
        // Second API call: Add complaint (required)
        try {
          const categoryName = complaintCategoriesList.find(cat => cat.value === complaintCategory)?.name;
          const complaintResponse = await addComplaint(
            categoryName,
            complaintDescription,
            complaintOrderId || order.publicId, // Use edited Order ID or fallback to current order
            complaintUserId || ("C" + zeroFill(order.userByUserId.id, 5)), // Use edited User ID or fallback to current user
            0, // Status
            "", // Compensation value (empty since field removed)
            "", // Comment (empty since field removed)
            complaintImageUploadFiles,
          );
          
          const { data: complaintData } = complaintResponse;
          if (complaintData.result.isSuccess) {
            showSuccessNotification("Order marked for rewash and complaint added successfully");
          } else {
            showErrorNotification("Order marked for rewash but failed to add complaint: " + complaintData.result.description);
            setIsLoading(false);
            return;
          }
        } catch (complaintEx) {
          showErrorNotification("Order marked for rewash but failed to add complaint: " + complaintEx.message);
          setIsLoading(false);
          return;
        }
        
        setMarkForRewashModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(rewashData.result.description);
        setIsLoading(false);
      }
    }
    catch (ex) {
      showErrorNotification("Failed to mark order for rewash");
      setIsLoading(false);
    }
  };

  const accessOrderRewardPage = (id) => {
    let history = createHistory();
    history.push("/admin/orders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  // Complaint handling functions
  const handleComplaintImageChange = (e) => {
    const files = Array.from(e.target.files);
    const promises = files.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    });
    Promise.all(promises)
      .then((base64Images) => {
        setComplaintImages((prevImages) => [...prevImages, ...base64Images]);
        setComplaintImageUploadFiles((prevFiles) => [...prevFiles, ...files]);
      })
      .catch((error) => {
        console.error('Error converting files to base64:', error);
      });
  };

  const removeComplaintImage = (index) => {
    const newImages = [...complaintImages];
    newImages.splice(index, 1);
    setComplaintImages(newImages);
    const newFiles = [...complaintImageUploadFiles];
    newFiles.splice(index, 1);
    setComplaintImageUploadFiles(newFiles);
  };

  const clearComplaintForm = () => {
    setComplaintCategory(0); // Default to "Rewash"
    setComplaintDescription("");
    setComplaintImages([]);
    setComplaintImageUploadFiles([]);
    setComplaintOrderId("");
    setComplaintUserId("");
    if (complaintFileInputRef.current) {
      complaintFileInputRef.current.value = null;
    }
  };





  const fetchOrderDetails = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getOrderDetails(currentOrderId);
      const { data } = response;
      const responseCities = await getCities(localStorage.getItem("selectedCountry"));
      const responseDrivers = await getAllActiveDrivers();
      const responseStatusList = await getAllStatus();
      const responseSlotsList = await getAllSlots();
      const responseLaundries = await getAllActiveLaundries();
      const responsePendingApproval = await getPendingApprovalOrderRecords(currentOrderId);
      const responseServices = await getAllServices();

     
      var responseSubscription;
      if (data.data.subscriptionId != null) {
        responseSubscription = await getSubscriptionDetails(data.data.subscriptionId);
      }
      if (data.result.isSuccess) {
        setServices(responseServices.data.data);
        setDrivers(responseDrivers.data.data);
        setLaundries(responseLaundries.data.data);
        setStatusList(responseStatusList.data.data);
        setCities(responseCities.data.data);
        setSlots(responseSlotsList.data.data);
        if (data.data.subscriptionId != null) {
          setSubscription(responseSubscription.data.data);
        }
        setPendingApprovalRecords(responsePendingApproval.data.data);
        setOrder(tidyUpOrder(data.data));
        setTimeout(() => {
          initMap(data.data.pickupLocationCoordinates, data.data.dropoffLocationCoordinates);
        }, 3500);
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch order details " + ex);
    }
    setIsLoading(false);
  };

  const getTableRow = (name, value) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold", width: "50%" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px", wordWrap: "break-word", whiteSpace: "normal !important", width: "50%" }}>{value}</TableCell>
      </TableRow>
    );
  };


  const getTableRowNotes = (name, value) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold", width: "50%" }}>
          {name}
          <div style={{ display: "inline", marginLeft: "15px" }}
            onClick={() => {
              setNotesModal(true);
            }}
          ><Box component={Edit} color="orange" /></div>
        </TableCell>
        <TableCell style={{ fontSize: "16px", wordWrap: "break-word", whiteSpace: "normal !important", width: "50%" }}>{value}</TableCell>
      </TableRow>
    );
  };

  const getServiceTableRow = (img, name, quantity, type, serviceTypes) => {
    return (
      <TableRow>
        <TableCell>
          <img src={img} width="25px" />
        </TableCell>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{quantity}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>
          {type}
          {serviceTypes && serviceTypes.length > 0 && (
            <div style={{ marginTop: "4px", display: "flex", flexWrap: "wrap", gap: "4px" }}>
              {serviceTypes.map((t, idx) => (
                <span
                  key={idx}
                  style={{
                    backgroundColor: "#5e72e4",
                    color: "#fff",
                    borderRadius: "20px",
                    padding: "2px 10px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {t.name} ×{t.qty}
                </span>
              ))}
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  };

  const getDriverTagTableRow = (img, name, weight, tag, isAdditional, photo) => {
    return (
      <TableRow>
        <TableCell>
          <img src={img} width="25px" />
        </TableCell>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{weight} kg</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{tag}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{isAdditional}</TableCell>
        <TableCell>
          {photo != null && photo !== '' ? <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(photo);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div> : ''}
        </TableCell>
      </TableRow>
    );
  };

  const getLaundryTagTableRow = (img, name, tag, isAdditional, isPickedUp, photo) => {
    return (
      <TableRow>
        <TableCell>
          <img src={img} width="25px" />
        </TableCell>
        <TableCell style={{ fontSize: "16px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "16px" }}>{tag}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{isAdditional}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{isPickedUp}</TableCell>
        <TableCell>
          {photo != null && photo !== '' ? <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(photo);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div> : ''}
        </TableCell>
      </TableRow>
    );
  };

  const getSpecialRequestTableRow = (title, notes, img) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px" }}>{title}</TableCell>
        <TableCell style={{ fontSize: "16px" }}>{notes}</TableCell>
        <TableCell>
          <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(img);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
    );
  };


  const getLaundryPhotosTableRow = (notes, img) => {
    return (
      <TableRow>
        <TableCell style={{ fontSize: "16px" }}>{notes}</TableCell>
        <TableCell>
          <div className="actions-right">
            <Tooltip title="View Image">
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  openInNewTab(img);
                }}
              >
                <Box component={Image} />
              </Button>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
    );
  };

  const updateShowToUserAction = async (photoId) => {
    setIsLoading(true);
    try {
      const response = await updateShowToUser(order.id, photoId, showToUser);
      const { data } = response;
      if (data.result.isSuccess) {
        setExecuteUpdate(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update order");
      setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    fetchOrderDetails();
  }, [forceRefresh]);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">
                        Order #{order != null ? order.publicId : currentOrderId}
                        {order != null && order.isQuickPickup === 1 ? (
                          <span
                            title="Placed without items — priced by the laundry, collected by the driver at dropoff"
                            style={{
                              marginLeft: "10px",
                              padding: "3px 10px",
                              borderRadius: "12px",
                              backgroundColor: "#ff9800",
                              color: "#fff",
                              fontSize: "12px",
                              fontWeight: 600,
                              verticalAlign: "middle",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Quick Pickup
                          </span>
                        ) : null}
                        <Grid
                          container
                          className="pl-4"
                          style={{
                            display: "inline-block",
                          }}
                        >
                          <Tooltip
                            title="Update Order Status"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedSuccess,
                              }}
                              onClick={() => {
                                setUpdateStatusModal(true);
                              }}
                            >
                              <span>Update Status</span>
                            </Button>
                          </Tooltip>
                          {order != null && order.isWelcomeKit === 0 ? <Tooltip
                            title="Assign Pickup Driver"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedWarning,
                              }}
                              onClick={() => {
                                setAssignDriverModal(true);
                                setAssignDriverType(1);
                              }}
                            >
                              <span>Assign Pickup Driver</span>
                            </Button>
                          </Tooltip> : ''}

                          <Tooltip
                            title="Assign Dropoff Driver"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedError,
                              }}
                              onClick={() => {
                                setAssignDriverModal(true);
                                setAssignDriverType(0);
                              }}
                            >
                              <span>Assign Dropoff Driver</span>
                            </Button>
                          </Tooltip>
                          <Tooltip
                            title="Update Pickup/Dropoff"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedInfo,
                              }}
                              onClick={() => {
                                setUpdateOrderModal(true);
                              }}
                            >
                              <span>Update Pickup/Dropoff</span>
                            </Button>
                          </Tooltip>

                          {order != null && order.isWelcomeKit === 0 ? <Tooltip
                            title="Assign Laundry"
                            style={{ margin: "5px" }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              classes={{
                                root: classes.buttonContainedPrimary,
                              }}
                              onClick={() => {
                                setAssignLaundryModal(true);
                              }}
                            >
                              <span>Assign Laundry</span>
                            </Button>
                          </Tooltip> : ''}
                          {
                            order != null && order.isWelcomeKit === 0 ? <Tooltip
                              title="Mark For Rewash"
                              style={{ margin: "5px" }}
                            >
                              <Button
                                variant="contained"
                                size="small"
                                classes={{
                                  root: classes.buttonContainedError,
                                }}
                                onClick={() => {
                                  // Set default values for complaint fields
                                  setComplaintOrderId(order.publicId);
                                  setComplaintUserId("C" + zeroFill(order.userByUserId.id, 5));
                                  setComplaintCategory(0); // Default to "Rewash"
                                  setMarkForRewashModal(true);
                                }}
                              >
                                <span>Mark For Rewash</span>
                              </Button>
                            </Tooltip> : ''
                          }
                        </Grid>
                      </Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              {isLoading || order == null ? (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                  <div className="text-center" style={{ width: "20%" }}>
                    <LoadingAnimation />{" "}
                  </div>
                </Box>
              ) : (
                <>
                  <Grid container>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Order Info</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>

                        <Grid container justify="space-between">
                          <Grid item xs={12} sm={12} md={6} >
                            <TableContainer
                              style={{
                                paddingLeft: "26px",
                                paddingRight: "26px",
                              }}
                            >
                              <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                              >
                                {getTableRow("Order ID", order.publicId)}
                                {getTableRow(
                                  "Order By",
                                  order.userByUserId.firstName +
                                  " " +
                                  order.userByUserId.lastName
                                )}
                                {getTableRow(
                                  "Customer ID",
                                  "C" + zeroFill(order.userByUserId.id, 5)
                                )}
                                {getTableRow(
                                  "Mobile Number",
                                  "+" + order.userByUserId.mobileNumber
                                )}
                                {getTableRow(
                                  "Price",
                                  order.priceWithoutDiscountAndVat + " " + currency
                                )}
                                {getTableRow(
                                  "Pro Discount",
                                  order.proDiscount.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Minimum Order Adjustment",
                                  order.minimumAmountFee.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Discount",
                                  order.discountAmount.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Delivery Fee",
                                  order.deliveryFee != null ? order.deliveryFee.toFixed(3) + " " + currency : "0.000 " + currency
                                )}
                                {getTableRow(
                                  "VAT",
                                  order.vat.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Final Price",
                                  order.finalPrice.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Paid Using Wallet",
                                  order.walletBalanceUsed.toFixed(3) + " " + currency
                                )}
                                {getTableRow(
                                  "Payment Method",
                                  order.paymentMethodName
                                )}
                              </Box>
                            </TableContainer>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <TableContainer
                              style={{
                                paddingLeft: "26px",
                                paddingRight: "26px",
                              }}
                            >
                              <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                              >
                                {getTableRow(
                                  "Email Address",
                                  order.userByUserId.emailAddress
                                )}
                                {getTableRow(
                                  "Coupon Code Used",
                                  order.couponCode
                                )}
                                {getTableRow(
                                  "Status",
                                  order.statusTextByStatus.textEn + (
                                    order != null && order.isWelcomeKit === 0 ? (
                                      order.status == 3 ? order.droppedOffAtLaundryOn ? " (Dropped At Laundry)" : " (Not Dropped At Laundry Yet)" : ""
                                    ) + (
                                        order.status > 3 ? getIsPickedFromLaundry(order) ? " (Picked from Laundry)" : " (Not Picked from Laundry Yet)" : ""
                                      ) : ''
                                  )
                                )}
                                {getTableRow(
                                  "Assigned Laundry",
                                  order.laundryByAssignedLaundry != null
                                    ? order.laundryByAssignedLaundry.name
                                    : ""
                                )}
                                {getTableRow(
                                  "Assigned Pickup Driver",
                                  order.driverByAssignedDriver != null
                                    ? order.driverByAssignedDriver.fullNameEn
                                    : ""
                                )}
                                {getTableRow(
                                  "Assigned Dropoff Driver",
                                  order.driverByAssignedDriverDropoff != null
                                    ? order.driverByAssignedDriverDropoff.fullNameEn
                                    : ""
                                )}
                                {getTableRow(
                                  "Need More Bags",
                                  order.needMoreBags == 1 ? "Yes" : "No"
                                )}
                                {getTableRow(
                                  "Deliver Earlier If Available",
                                  order.deliverEarlier == 1 ? "Yes" : "No"
                                )}
                                {getTableRow("Placed On", order.placedOnText)}
                                {getTableRow(
                                  "DateTime Picked Up",
                                  order.pickupDateTimeText
                                )}
                                {getTableRow(
                                  "DateTime Dropped At Laundry",
                                  order.droppedOffAtLaundryOnText
                                )}
                                {getTableRow(
                                  "DateTime Dropped Off",
                                  order.dropoffDateTimeText
                                )}
                              </Box>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Pickup/Dropoff Details</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>

                        <Grid container justify="space-between">
                          <Grid item xs={12} sm={12} md={8}>
                            <TableContainer
                              style={{
                                paddingLeft: "26px",
                                paddingRight: "26px",
                              }}
                            >
                              <Box
                                component={Table}
                                alignItems="center"
                                marginBottom="0!important"
                              >
                                {order != null && order.isWelcomeKit === 0 ? <>{getTableRow(
                                  "Pickup Address",
                                  (order.pickupFlat != null &&
                                    order.pickupFlat != ""
                                    ? "Flat " + order.pickupFlat + ", "
                                    : "") +
                                  " House/Building " +
                                  order.pickupHouse +
                                  ", Road " +
                                  order.pickupRoad + (order.pickupDistrictName != null &&
                                    order.pickupDistrictName != ""
                                    ? ", " + order.pickupDistrictName
                                    : "")
                                )}
                                  {getTableRow(
                                    "Pickup Block",
                                    order.pickupBlock
                                  )}
                                  {getTableRow(
                                    "Pickup City",
                                    order.cityByPickupCityId.cityEn
                                  )}
                                  {order.pickupShortAddress != null ??
                                    getTableRow(
                                      "Pickup Short Address",
                                      order.pickupShortAddress
                                    )}
                                  {getTableRow(
                                    "Pickup Location Type",
                                    order.pickupAddressType
                                  )}
                                  {order.pickupAddressInstructions != null ??
                                    getTableRow(
                                      "Pickup Address Instructions",
                                      order.pickupAddressInstructions
                                    )}
                                  {getTableRow(
                                    "Pickup Instructions",
                                    order.pickupInstructions
                                  )}
                                  {
                                    getTableRow(
                                      "Booked Pickup Datetime",
                                      order.pickupDateText +
                                      " " +
                                      (order.availabilitySlotByPickupTimeslot && order.availabilitySlotByPickupTimeslot.startTime ? order.availabilitySlotByPickupTimeslot.startTime : '') +
                                      " - " +
                                      (order.availabilitySlotByPickupTimeslot && order.availabilitySlotByPickupTimeslot.endTime ? order.availabilitySlotByPickupTimeslot.endTime : '')
                                    )}
                                </> : ''}
                                {getTableRow(
                                  "Dropoff Address",
                                  (order.dropoffFlat != null &&
                                    order.dropoffFlat != ""
                                    ? "Flat " + order.dropoffFlat + ", "
                                    : "") +
                                  " House/Building " +
                                  order.dropoffHouse +
                                  ", Road " +
                                  order.dropoffRoad + (order.dropoffDistrictName != null &&
                                    order.dropoffDistrictName != ""
                                    ? ", " + order.dropoffDistrictName
                                    : "")
                                )}
                                {getTableRow(
                                  "Dropoff Block",
                                  order.dropoffBlock
                                )}
                                {getTableRow(
                                  "Dropoff City",
                                  order.cityByDropoffCityId.cityEn
                                )}
                                {order.dropoffShortAddress != null ??
                                  getTableRow(
                                    "Dropoff Short Address",
                                    order.dropoffShortAddress
                                  )}
                                {getTableRow(
                                  "Dropoff Location Type",
                                  order.dropoffAddressType
                                )}
                                {order.dropoffAddressInstructions != null ??
                                  getTableRow(
                                    "Dropoff Address Instructions",
                                    order.dropoffAddressInstructions
                                  )}
                                {getTableRow(
                                  "Dropoff Instructions",
                                  order.dropoffInstructions
                                )}
                                {getTableRow(
                                  "Booked Dropoff Datetime",
                                  order.dropoffDateText +
                                  " " +
                                  (order.availabilitySlotByDropoffTimeslot && order.availabilitySlotByDropoffTimeslot.startTime ? order.availabilitySlotByDropoffTimeslot.startTime : '') +
                                  " - " +
                                  (order.availabilitySlotByDropoffTimeslot && order.availabilitySlotByDropoffTimeslot.endTime ? order.availabilitySlotByDropoffTimeslot.endTime : '')
                                )}
                              </Box>
                            </TableContainer>
                          </Grid>
                          <Grid item xs={12} sm={12} md={4}>
                            <div
                              style={{ height: order != null && order.isWelcomeKit === 1 ? `330px` : `660px` }}
                              className="map-canvas"
                              id="map-default"
                              ref={mapRef}
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                  <Grid container justify="space-between">
                    <Grid item xs={12} sm={12} md={6}>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Ordered Services</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  {order.subscriptionId != null ? 'Frequency' : 'Service'}
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  {order.subscriptionId != null ? 'Max Number of Bags' : 'Quantity'}
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  {order.subscriptionId != null ? 'Subscription ID' : 'Type'}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.subscriptionId != null ?
                                (getServiceTableRow(
                                  subscription.subscriptionPackageByPackageId.imageUrl,
                                  subscription.subscriptionPackageByPackageId.frequency === 1 ? 'Weekly' : 'Twice a week',
                                  subscription.subscriptionPackageByPackageId.upToBags,
                                  "S" + zeroFill(subscription.id, 5)
                                ))
                                : order.orderServicesById.map(function (
                                  service,
                                  i
                                ) {
                                  const serviceTypes =
                                    service.typeQuantities != null &&
                                    service.serviceByServiceId.servicePricings != null
                                      ? service.serviceByServiceId.servicePricings
                                          .filter(
                                            (p) =>
                                              p.serviceTypeId != null &&
                                              service.typeQuantities[p.serviceTypeId] != null
                                          )
                                          .map((p) => ({
                                            name: p.serviceType?.nameEn ?? "",
                                            qty: service.typeQuantities[p.serviceTypeId],
                                          }))
                                          .filter((t) => t.name !== "")
                                      : [];
                                  return getServiceTableRow(
                                    service.serviceByServiceId.imageUrl,
                                    service.serviceByServiceId.nameEn,
                                    service.quantity,
                                    service.serviceByServiceId.isPerItem === 0
                                      ? "Pay Per Bag"
                                      : "Pay Per Item",
                                    serviceTypes
                                  );
                                })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Order Status History</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Status
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  DateTime
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderStatusHistoriesById.sort((a, b) => new Date(b.onDatetime) - new Date(a.onDatetime)).map(function (
                                status,
                                i
                              ) {
                                return getTableRow(
                                  status.statusTextByStatus.textEn,
                                  dateFormat(
                                    new Date(status.onDatetime),
                                    "d-mmm-yyyy hh:MM TT"
                                  )
                                );
                              })}
                              {
                                order.markedForRewashOn != null ? getTableRow(
                                  "Marked for Rewash",
                                  dateFormat(
                                    new Date(order.markedForRewashOn),
                                    "d-mmm-yyyy hh:MM TT"
                                  )
                                ) : ''
                              }
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>


                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Delivery/Laundry Photos
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Action
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Datetime
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderDeliveryPhotosById.map(
                                function (op, i) {
                                  return getSpecialRequestTableRow(
                                    op.statusTextByStatus.textEn,
                                    dateFormat(
                                      new Date(op.addedOn),
                                      "d-mmm-yyyy hh:MM TT"
                                    ),
                                    op.photoUrl
                                  );
                                }
                              )}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Laundry/Pre Wash Photos
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box component={Table} alignItems="center" marginBottom="0!important">
                            <TableHead>
                              <TableRow>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Image
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Service
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Bag
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Issue
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Actions
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Show To User
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.laundryPhotoRequestsById.filter(op => op.requestType === 'pre-wash').map(function (op, i) {
                                const service = services.find((s) => s.id === op.serviceId);
                                const bag = services.find((s) => s.id === op.bagId);
                                return (
                                  <TableRow key={i}>
                                    <TableCell>
                                      <img src={service.imageUrl} width="25px" />
                                    </TableCell>
                                    <TableCell>{service.nameEn}</TableCell>
                                    <TableCell>{bag.nameEn}</TableCell>
                                    <TableCell>{op.issue}</TableCell>
                                    <TableCell>
                                      <div className="actions-right">
                                        <Tooltip title="View Image">
                                          <Button
                                            size="small"
                                            color="primary"
                                            variant="contained"
                                            onClick={() => {
                                              openInNewTab(op.photoUrl);
                                            }}
                                          >
                                            <Box component={Image} />
                                          </Button>
                                        </Tooltip>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div style={{ display: "inline-block" }}>
                                        {op.showToUser === 1 ? (
                                          <Tooltip title="Hide From User">
                                            <Button
                                              size="small"
                                              classes={{
                                                root: classes.buttonContainedInfo,
                                              }}
                                              variant="contained"
                                              style={{ marginLeft: "5px" }}
                                              onClick={() => {
                                                warningAlert(
                                                  "Hide From User",
                                                  `Are you sure you would like to hide the photo for service ID ${op.serviceId}?`,
                                                  async () => {
                                                    setShowToUser(0);
                                                    setAlert(null);
                                                    setExecuteUpdate(true);
                                                    updateShowToUserAction(op.id);
                                                  }
                                                );
                                              }}
                                            >
                                              <Box component={Block} />
                                            </Button>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip title="Show To User">
                                            <Button
                                              size="small"
                                              classes={{
                                                root: classes.buttonContainedSuccess,
                                              }}
                                              variant="contained"
                                              style={{ marginLeft: "5px" }}
                                              onClick={() => {
                                                warningAlert(
                                                  "Show To User",
                                                  `Are you sure you would like to show the photo for service ID ${op.serviceId}?`,
                                                  async () => {
                                                    setShowToUser(1);
                                                    setAlert(null);
                                                    setExecuteUpdate(true);
                                                    updateShowToUserAction(op.id);
                                                  }
                                                );
                                              }}
                                            >
                                              <Box component={Check} />
                                            </Button>
                                          </Tooltip>
                                        )}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>


                      {/* <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Laundry Photos
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Datetime
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Actions
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.orderLaundryPhotosById.map(
                                function (op, i) {
                                  return getLaundryPhotosTableRow(
                                    dateFormat(
                                      new Date(op.addedOn),
                                      "d-mmm-yyyy hh:MM TT"
                                    ),
                                    op.photoUrl
                                  );
                                }
                              )}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card> */}
                    </Grid>

                    <Grid item xs={12} sm={12} md={6}>
                      {pendingApprovalRecords != null && pendingApprovalRecords.length > 0 ? (<Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Pending Approval Updates</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>

                        {pendingApprovalRecords.map(function (
                          pendingApprovalRecord,
                          i
                        ) {
                          return (<TableContainer
                            style={{
                              paddingLeft: "26px",
                              paddingRight: "26px",
                            }}
                          >
                            <br />U{zeroFill(pendingApprovalRecord.id, 5)} - Pending Changes ({pendingApprovalRecord.differenceTotal} {currency})&emsp;
                            <Tooltip title="Approve">
                              <Button
                                size="small"
                                classes={{
                                  root: classes.buttonContainedSuccess,
                                }}
                                variant="contained"
                                style={{ marginLeft: "5px" }}
                                onClick={() => {
                                  warningAlert("Approve Record", "Are you sure you would like to approve the request U" + zeroFill(pendingApprovalRecord.id, 5) + "?", async () => {
                                    setAlert(null);
                                    recordUpdateStatusAction([pendingApprovalRecord.id], 1);
                                  })
                                }}
                              >
                                Approve
                              </Button>
                            </Tooltip>

                            <Tooltip title="Reject">
                              <Button
                                size="small"
                                classes={{
                                  root: classes.buttonContainedError,
                                }}
                                variant="contained"
                                style={{ marginLeft: "5px" }}
                                onClick={() => {
                                  warningAlert("Reject Record", "Are you sure you would like to reject the request U" + zeroFill(pendingApprovalRecord.id, 5) + "?", async () => {
                                    setAlert(null);
                                    recordUpdateStatusAction([pendingApprovalRecord.id], -1);
                                  })
                                }}
                              >
                                Reject
                              </Button>
                            </Tooltip>
                            <br />
                            <Box
                              component={Table}
                              alignItems="center"
                              marginBottom="0!important"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Image
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Service
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    New Quantity
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Type
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {pendingApprovalRecord.orderBagUpdateServiceRecordDtos.map(function (
                                  service,
                                  j
                                ) {
                                  if (service.newQuantity !== 0) {
                                    return getServiceTableRow(
                                      service.service.imageUrl,
                                      service.service.nameEn,
                                      service.newQuantity,
                                      service.service.isPerItem === 0
                                        ? "Pay Per Bag"
                                        : "Pay Per Item"
                                    );
                                  }
                                })}
                              </TableBody>
                            </Box>
                          </TableContainer>);
                        })}
                      </Card>) : ''}
                      {order != null && order.isWelcomeKit === 0 ? <><Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Special Requests</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            {getTableRow("Scent", order.scent)}
                            {getTableRow("Starch", order.starch)}
                            {/* {getTableRow(
                              "Thobe Back Crease",
                              order.thobeBackCrease
                            )} */}
                            {getTableRow("Ghetra Type + Starch", order.ghetra)}
                            {/* {getTableRow(
                              "Shirts Sleeve Crease",
                              order.shirtsSleeveCrease
                            )}
                            {getTableRow(
                              "Pants Travelers Crease",
                              order.pantsTravelersCrease
                            )} */}
                            {getTableRow(
                              "Notes",
                              order.notes
                            )}
                            {getTableRowNotes(
                              "Order Level Notes",
                              order.portalNotes
                            )}
                            {getTableRow(
                              "User Level Notes",
                              order.userByUserId.portalNotes
                            )}
                          </Box>
                        </TableContainer>
                      </Card>
                        <Card>
                          <CardHeader
                            subheader={
                              <>
                                <Box component="span">
                                  Special Requests - Notes/Images
                                </Box>
                              </>
                            }
                            classes={{ root: classes.cardHeaderRoot }}
                          ></CardHeader>
                          <TableContainer
                            style={{
                              paddingLeft: "26px",
                              paddingRight: "26px",
                            }}
                          >
                            <Box
                              component={Table}
                              alignItems="center"
                              marginBottom="0!important"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Title
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Notes
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {order.orderSpecialRequestPhotosById.map(
                                  function (sr, i) {
                                    return getSpecialRequestTableRow(
                                      sr.title,
                                      sr.notes,
                                      sr.photoUrl
                                    );
                                  }
                                )}
                              </TableBody>
                            </Box>
                          </TableContainer>
                        </Card></> : ''}

                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Pickup/Driver Tags</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Weight
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Tag
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Additional
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Photo
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.qrTagsById.map(function (
                                qrTag,
                                i
                              ) {
                                if (qrTag.flow == 1) {
                                  return '';
                                }
                                return getDriverTagTableRow(
                                  qrTag.serviceByServiceId.bagImageUrl,
                                  qrTag.serviceByServiceId.nameEn,
                                  qrTag.weight,
                                  qrTag.tag,
                                  qrTag.isAdditional == 1
                                    ? "Yes"
                                    : "No",
                                  qrTag.photoUrl
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>

                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">Dropoff/Laundry Tags</Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box
                            component={Table}
                            alignItems="center"
                            marginBottom="0!important"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Image
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Service
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Tag
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Additional
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Is Picked Up
                                </TableCell>
                                <TableCell
                                  classes={tableCellHeadTableHeadClassesObj}
                                >
                                  Photo
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {order.qrTagsById.map(function (
                                qrTag,
                                i
                              ) {
                                if (qrTag.flow == 0) {
                                  return '';
                                }
                                return getLaundryTagTableRow(
                                  qrTag.serviceByServiceId.bagImageUrl,
                                  qrTag.serviceByServiceId.nameEn,
                                  qrTag.tag,
                                  qrTag.isAdditional == 1
                                    ? "Yes"
                                    : "No",
                                  qrTag.isPickedUp == 1
                                    ? "Yes"
                                    : "No",
                                  qrTag.photoUrl
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>
                      <Card>
                        <CardHeader
                          subheader={
                            <>
                              <Box component="span">
                                Laundry/Post Wash Photos
                              </Box>
                            </>
                          }
                          classes={{ root: classes.cardHeaderRoot }}
                        ></CardHeader>
                        <TableContainer
                          style={{
                            paddingLeft: "26px",
                            paddingRight: "26px",
                          }}
                        >
                          <Box component={Table} alignItems="center" marginBottom="0!important">
                            <TableHead>
                              <TableRow>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Image
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Service
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Bag
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Issue
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Actions
                                </TableCell>
                                <TableCell classes={tableCellHeadTableHeadClassesObj}>
                                  Show To User
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                            {order.laundryPhotoRequestsById.filter(op => op.requestType === 'post-wash').map(function (op, i) {
                                const service = services.find((s) => s.id === op.serviceId);
                                const bag = services.find((s) => s.id === op.bagId);
                                return (
                                  <TableRow key={i}>
                                    <TableCell>
                                      <img src={service.imageUrl} width="25px" />
                                    </TableCell>
                                    <TableCell>{service.nameEn}</TableCell>
                                    <TableCell>{bag.nameEn}</TableCell>
                                    <TableCell>{op.issue}</TableCell>
                                    <TableCell>
                                      <div className="actions-right">
                                        <Tooltip title="View Image">
                                          <Button
                                            size="small"
                                            color="primary"
                                            variant="contained"
                                            onClick={() => {
                                              openInNewTab(op.photoUrl);
                                            }}
                                          >
                                            <Box component={Image} />
                                          </Button>
                                        </Tooltip>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div style={{ display: "inline-block" }}>
                                        {op.showToUser === 1 ? (
                                          <Tooltip title="Hide From User">
                                            <Button
                                              size="small"
                                              classes={{
                                                root: classes.buttonContainedInfo,
                                              }}
                                              variant="contained"
                                              style={{ marginLeft: "5px" }}
                                              onClick={() => {
                                                warningAlert(
                                                  "Hide From User",
                                                  `Are you sure you would like to hide the photo for service ID ${op.serviceId}?`,
                                                  async () => {
                                                    setShowToUser(0);
                                                    setAlert(null);
                                                    setExecuteUpdate(true);
                                                    updateShowToUserAction(op.id);
                                                  }
                                                );
                                              }}
                                            >
                                              <Box component={Block} />
                                            </Button>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip title="Show To User">
                                            <Button
                                              size="small"
                                              classes={{
                                                root: classes.buttonContainedSuccess,
                                              }}
                                              variant="contained"
                                              style={{ marginLeft: "5px" }}
                                              onClick={() => {
                                                warningAlert(
                                                  "Show To User",
                                                  `Are you sure you would like to show the photo for service ID ${op.serviceId}?`,
                                                  async () => {
                                                    setShowToUser(1);
                                                    setAlert(null);
                                                    setExecuteUpdate(true);
                                                    updateShowToUserAction(op.id);
                                                  }
                                                );
                                              }}
                                            >
                                              <Box component={Check} />
                                            </Button>
                                          </Tooltip>
                                        )}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Box>
                        </TableContainer>
                      </Card>
                    </Grid>
                  </Grid>
                </>
              )}
            </Card>
          </Grid>
        </Grid>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={notesModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setNotesModal(false)}
        >
          <DialogTitle
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.modalTitle}>
              Order Notes
            </h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Notes</FormLabel>
                <OutlinedInput
                  fullWidth
                  type="text"
                  placeholder="notes"
                  value={portalNotes ?? ""}
                  multiline={true}
                  rows={5}
                  onChange={(e) => setPortalNotes(e.target.value)}
                />
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setNotesModal(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                updateOrderNotesAction()
              }

              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Save
            </Button>

          </DialogActions>
        </Dialog>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={assignLaundryModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAssignLaundryModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Assign Laundry</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Laundry</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={assignedLaundryId}
                    onChange={(e) => setAssignedLaundryId(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {laundries.map(function (laundry, i) {
                      return (
                        <MenuItem value={laundry.id}>
                          {laundry.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignLaundryModal(false)}>Cancel</Button>
            <Button
              onClick={() => assignLaundryAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={assignDriverModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setAssignDriverModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Assign {assignDriverType == 1 ? 'Pickup' : 'Dropoff'} Driver</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>Driver</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={assignedDriverId}
                    onChange={(e) => setAssignedDriverId(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {drivers.map(function (driver, i) {
                      return (
                        <MenuItem value={driver.id}>
                          {driver.fullNameEn}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignDriverModal(false)}>Cancel</Button>
            <Button
              onClick={() => assignDriverAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Assign
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateStatusModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateStatusModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Status</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <FormGroup>
                <FormLabel>New Status</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    {statusList.map(function (sts, i) {
                      if ((order != null && order.isWelcomeKit === 0) || ((sts.id === 1 || sts.id > 5) && sts.id !== 8) || (order != null && order.isWelcomeKit === 1 && sts.id === -2)) {
                        return <MenuItem value={sts.id}>{sts.textEn}</MenuItem>;
                      }
                    })}
                  </Select>
                </FormControl>
              </FormGroup>
              {newStatus === -2 ? (<FormGroup>
                <FormLabel>Refund to Wallet</FormLabel>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    value={refundToWallet}
                    onChange={(e) => setRefundToWallet(e.target.value)}
                    IconComponent={KeyboardArrowDown}
                  >
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
              </FormGroup>) : ''}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateStatusModal(false)}>Cancel</Button>
            <Button
              onClick={() => updateStatusAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateOrderModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateOrderModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Pickup/Dropoff</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              <Grid container justify="space-between">
                {order != null && order.isWelcomeKit === 0 ? <Grid item xs={12} sm={12} md={6}>
                  <FormGroup>
                    <FormLabel>Pickup Date</FormLabel>
                    <DatePicker
                      selected={pickupDate}
                      fullWidth
                      customInput={<OutlinedInput fullWidth />}
                      onChange={(date) => setPickupDate(date)}
                      dateFormat="MMMM d, yyyy"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup Timeslot</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={pickupTimeslot}
                        onChange={(e) => setPickupTimeslot(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {slots
                          .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                          .map(function (slot, i) {
                            if (
                              pickupDate != null &&
                              slot.dayId == pickupDate.getDay() + 1 &&
                              (slot.deliveryType == 0 || slot.deliveryType == 2) && slot.isSubscription == 0
                            ) {
                              return (
                                <MenuItem value={slot.id}>
                                  {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                </MenuItem>
                              );
                            }
                          })}
                      </Select>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Flat</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Flat"
                      value={pickupFlat ?? ""}
                      onChange={(e) => setPickupFlat(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Building/House</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Building/House"
                      value={pickupHouse ?? ""}
                      onChange={(e) => setPickupHouse(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Road</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Road"
                      value={pickupRoad ?? ""}
                      onChange={(e) => setPickupRoad(e.target.value)}
                    />
                  </FormGroup>

                  {isSaudi() ? <FormGroup>
                    <FormLabel>Pickup - District Name</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="District Name"
                      value={pickupDistrictName ?? ""}
                      onChange={(e) => setPickupDistrictName(e.target.value)}
                    />
                  </FormGroup> : ''}
                  <FormGroup>
                    <FormLabel>Pickup - Block</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Block"
                      value={pickupBlock ?? ""}
                      onChange={(e) => setPickupBlock(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - City</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={pickupCityId}
                        onChange={(e) => setPickupCityId(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {cities.map(function (city, i) {
                          return (
                            <MenuItem value={city.id}>{city.cityEn}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </FormGroup>

                  {isSaudi() ? <FormGroup>
                    <FormLabel>Pickup - Short Address</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Short Address"
                      value={pickupShortAddress ?? ""}
                      onChange={(e) => setPickupShortAddress(e.target.value)}
                    />
                  </FormGroup> : ''}

                  <FormGroup>
                    <FormLabel>Pickup - Address Type</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={pickupAddressType}
                        onChange={(e) => setPickupAddressType(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        <MenuItem value={"Villa"}>Villa</MenuItem>
                        <MenuItem value={"Apt"}>Apt</MenuItem>
                        <MenuItem value={"Hotel"}>Hotel</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Address Instructions</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Address Instructions"
                      value={pickupAddressInstructions ?? ""}
                      onChange={(e) =>
                        setPickupAddressInstructions(e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Location Coordintaes</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="XX.XXXXXX,XX.XXXXXX"
                      value={pickupLocationCoordinates ?? ""}
                      onChange={(e) =>
                        setPickupLocationCoordinates(e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Pickup - Instructions</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={pickupInstructions}
                        onChange={(e) => setPickupInstructions(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        <MenuItem value={"Ring the Bell"}>
                          Ring the Bell
                        </MenuItem>
                        <MenuItem value={"Call Me"}>Call Me</MenuItem>
                        <MenuItem value={"Pick up at Door"}>
                          Pick up at Door
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                </Grid> : ''}

                <Grid item xs={12} sm={12} md={order != null && order.isWelcomeKit === 0 ? 6 : 12}>
                  <FormGroup>
                    <FormLabel>Dropoff Date</FormLabel>
                    <DatePicker
                      selected={dropoffDate}
                      fullWidth
                      customInput={<OutlinedInput fullWidth />}
                      onChange={(date) => setDropoffDate(date)}
                      dateFormat="MMMM d, yyyy"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff Timeslot</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={dropoffTimeslot}
                        onChange={(e) => setDropoffTimeslot(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {slots
                          .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                          .map(function (slot, i) {
                            if (
                              dropoffDate != null &&
                              slot.dayId == dropoffDate.getDay() + 1 &&
                              (slot.deliveryType == 1 || slot.deliveryType == 2) && slot.isSubscription == 0
                            ) {
                              return (
                                <MenuItem value={slot.id}>
                                  {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                </MenuItem>
                              );
                            }
                          })}
                      </Select>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - Flat</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Flat"
                      value={dropoffFlat ?? ""}
                      onChange={(e) => setDropoffFlat(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - Building/House</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Building/House"
                      value={dropoffHouse ?? ""}
                      onChange={(e) => setDropoffHouse(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - Road</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Road"
                      value={dropoffRoad ?? ""}
                      onChange={(e) => setDropoffRoad(e.target.value)}
                    />
                  </FormGroup>


                  {isSaudi() ? <FormGroup>
                    <FormLabel>Dropoff - District Name</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="District Name"
                      value={dropoffDistrictName ?? ""}
                      onChange={(e) => setDropoffDistrictName(e.target.value)}
                    />
                  </FormGroup> : ''}

                  <FormGroup>
                    <FormLabel>Dropoff - Block</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Block"
                      value={dropoffBlock ?? ""}
                      onChange={(e) => setDropoffBlock(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - City</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={dropoffCityId}
                        onChange={(e) => setDropoffCityId(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {cities.map(function (city, i) {
                          return (
                            <MenuItem value={city.id}>{city.cityEn}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </FormGroup>



                  {isSaudi() ? <FormGroup>
                    <FormLabel>Dropoff - Short Address</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Short Address"
                      value={dropoffShortAddress ?? ""}
                      onChange={(e) => setDropoffShortAddress(e.target.value)}
                    />
                  </FormGroup> : ''}

                  <FormGroup>
                    <FormLabel>Dropoff - Address Type</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={dropoffAddressType}
                        onChange={(e) => setDropoffAddressType(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        <MenuItem value={"Villa"}>Villa</MenuItem>
                        <MenuItem value={"Apt"}>Apt</MenuItem>
                        <MenuItem value={"Hotel"}>Hotel</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - Address Instructions</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Address Instructions"
                      value={dropoffAddressInstructions ?? ""}
                      onChange={(e) =>
                        setDropoffAddressInstructions(e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Dropoff - Location Coordintaes</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="XX.XXXXXX,XX.XXXXXX"
                      value={dropoffLocationCoordinates ?? ""}
                      onChange={(e) =>
                        setDropoffLocationCoordinates(e.target.value)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormLabel>Dropoff - Instructions</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={dropoffInstructions}
                        onChange={(e) => setDropoffInstructions(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        <MenuItem value={"Ring the Bell"}>
                          Ring the Bell
                        </MenuItem>
                        <MenuItem value={"Call Me"}>Call Me</MenuItem>
                        <MenuItem value={"Drop off at Door"}>
                          Drop off at Door
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateOrderModal(false)}>Cancel</Button>
            <Button
              onClick={() => updateOrderAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={markForRewashModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setMarkForRewashModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Mark for Rewash</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
              {/* Rewash Details Section */}
              <div style={{ marginBottom: "20px" }}>
                <h5 style={{ marginBottom: "15px", color: "#333" }}>Rewash Details</h5>
                <Grid container justify="space-between">
                  {order != null && order.isWelcomeKit === 0 ? <Grid item xs={12} sm={12} md={6}>
                    <FormGroup>
                      <FormLabel>Pickup Date</FormLabel>
                      <DatePicker
                        selected={rewashPickupDate}
                        fullWidth
                        customInput={<OutlinedInput fullWidth />}
                        onChange={(date) => setRewashPickupDate(date)}
                        dateFormat="MMMM d, yyyy"
                      />
                    </FormGroup>

                    <FormGroup>
                      <FormLabel>Pickup Timeslot</FormLabel>
                      <FormControl variant="outlined" fullWidth>
                        <Select
                          value={rewashPickupTimeslot}
                          onChange={(e) => setRewashPickupTimeslot(e.target.value)}
                          IconComponent={KeyboardArrowDown}
                        >
                          {slots
                            .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                            .map(function (slot, i) {
                              if (
                                rewashPickupDate != null &&
                                slot.dayId == rewashPickupDate.getDay() + 1 &&
                                (slot.deliveryType == 0 || slot.deliveryType == 2) && slot.isSubscription == 0
                              ) {
                                return (
                                  <MenuItem value={slot.id}>
                                    {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                  </MenuItem>
                                );
                              }
                            })}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Grid> : ''}

                  <Grid item xs={12} sm={12} md={order != null && order.isWelcomeKit === 0 ? 6 : 12}>
                    <FormGroup>
                      <FormLabel>Dropoff Date</FormLabel>
                      <DatePicker
                        selected={rewashDropoffDate}
                        fullWidth
                        customInput={<OutlinedInput fullWidth />}
                        onChange={(date) => setRewashDropoffDate(date)}
                        dateFormat="MMMM d, yyyy"
                      />
                    </FormGroup>

                    <FormGroup>
                      <FormLabel>Dropoff Timeslot</FormLabel>
                      <FormControl variant="outlined" fullWidth>
                        <Select
                          value={rewashDropoffTimeslot}
                          onChange={(e) => setRewashDropoffTimeslot(e.target.value)}
                          IconComponent={KeyboardArrowDown}
                        >
                          {slots
                            .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                            .map(function (slot, i) {
                              if (
                                rewashDropoffDate != null &&
                                slot.dayId == rewashDropoffDate.getDay() + 1 &&
                                (slot.deliveryType == 1 || slot.deliveryType == 2) && slot.isSubscription == 0
                              ) {
                                return (
                                  <MenuItem value={slot.id}>
                                    {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                  </MenuItem>
                                );
                              }
                            })}
                        </Select>
                      </FormControl>
                    </FormGroup>
                  </Grid>
                </Grid>
              </div>

              {/* Complaint Details Section */}
              <div style={{ borderTop: "1px solid #ddd", paddingTop: "20px" }}>
                <h5 style={{ marginBottom: "15px", color: "#333" }}>Complaint Details</h5>
                
                <FormGroup>
                  <FormLabel>Category</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select
                      value={complaintCategory}
                      onChange={(e) => setComplaintCategory(e.target.value)}
                      IconComponent={KeyboardArrowDown}
                    >
                      {complaintCategoriesList.map((cat) => (
                        <MenuItem key={cat.value} value={cat.value}>
                          {cat.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Description *</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="textarea"
                    placeholder="Description"
                    value={complaintDescription ?? ""}
                    multiline={true}
                    rows={3}
                    onChange={(e) => setComplaintDescription(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Images</FormLabel>
                  <input
                    type="file"
                    multiple
                    ref={complaintFileInputRef}
                    onChange={handleComplaintImageChange}
                  />
                  <div>
                    {complaintImages.map((image, index) => (
                      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', marginTop: '5px' }}>
                        <img src={image} alt={`Uploaded ${index}`} style={{ maxWidth: '80px', maxHeight: '80px', marginRight: '10px' }} />
                        <Button
                          size="small"
                          variant="outlined"
                          color="secondary"
                          onClick={() => removeComplaintImage(index)}
                          style={{ cursor: 'pointer' }}
                        >
                          <Box component={Clear} />
                        </Button>
                      </div>
                    ))}
                  </div>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Order ID *</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Order ID"
                    value={complaintOrderId}
                    disabled
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>User ID *</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="User ID"
                    value={complaintUserId}
                    disabled
                  />
                </FormGroup>


              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMarkForRewashModal(false)}>Cancel</Button>
            <Button
              onClick={() => markForRewashAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>



        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default OrderDetailsPage;
